import type { OrchestrationPhase, TaskDesignFreedom } from "@calcplan/ai-capabilities";

export type ModelEffortHint = "low" | "medium" | "high" | "xhigh";

/**
 * Spend reasoning where professional judgment changes the result, not where
 * the model is merely dispatching a deterministic tool. The API still caps
 * this request at the effort selected by the administrator and at the levels
 * supported by the current model.
 */
export function orchestrationEffortHint(input: {
  phase: OrchestrationPhase;
  designFreedom: TaskDesignFreedom;
  requiresVisualComposition: boolean;
  reviewableCapturePending: boolean;
  hasActionableVisualIssues: boolean;
  planComplete: boolean;
  visualReviewDone: boolean;
}): ModelEffortHint {
  if (input.phase === "planning"
    && (input.requiresVisualComposition || input.designFreedom === "open")) {
    return "xhigh";
  }

  // Images have already been produced at this point. Judging composition and
  // deciding a correction are the expensive cognitive operations; requesting
  // the capture itself remains medium.
  if ((input.phase === "execution" || input.phase === "verification")
    && (input.reviewableCapturePending || input.hasActionableVisualIssues)) {
    return "xhigh";
  }

  // This is normally a short transition request before the deterministic
  // final verifier takes over. The final response itself is generated locally.
  if (input.planComplete && input.visualReviewDone) return "low";

  return "medium";
}
